module.exports = require('./toPairs');



//////////////////
// WEBPACK FOOTER
// ./~/lodash/entries.js
// module id = 414
// module chunks = 0